<div class="flex justify-between gap-x-4" mat-dialog-title>
    <h1 class="text-3xl font-extrabold">Cambiar contraseña</h1>
    <button color="warn" mat-dialog-close mat-icon-button>
        <mat-icon>close</mat-icon>
    </button>
</div>

<div mat-dialog-content>
    <form
        class="mt-3 grid w-full gap-y-3"
        [formGroup]="passwordChangeForm"
        #userCreateNgForm="ngForm"
    >
        <mat-form-field class="w-full">
            <mat-label> Ingrese su antigua contraseña </mat-label>
            <input
                [type]="'password'"
                id="oldPassword"
                matInput
                [formControl]="passwordChangeForm.controls.oldPassword"
            />
            @if (passwordChangeForm.get('oldPassword').hasError('required')) {
            <mat-error>La contraseña es requerida.</mat-error>
            }
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label> Contraseña nueva </mat-label>
            <input
                [type]="'password'"
                id="newPassword"
                matInput
                [formControl]="passwordChangeForm.controls.newPassword"
            />
            @if (passwordChangeForm.get('newPassword').hasError('required')) {
            <mat-error>La contraseña es requerida.</mat-error>
            } @else if
            (passwordChangeForm.get('newPassword').hasError('minlength') ) {
            <mat-error>
                La contraseña debe tener mínimo 8 caracteres.
            </mat-error>
            } @else if
            (passwordChangeForm.get('newPassword').hasError('passwordCase') ) {
            <mat-error>
                La contraseña debe contener una letra mayúscula, una minúscula y
                un número mínimo.
            </mat-error>
            }
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label> Repita la nueva contraseña </mat-label>
            <input
                [type]="'password'"
                id="confirmNewPassword"
                matInput
                [formControl]="passwordChangeForm.controls.confirmNewPassword"
            />
            @if
            (passwordChangeForm.get('confirmNewPassword').hasError('required'))
            {
            <mat-error>La contraseña es requerida.</mat-error>
            } @else if (passwordChangeForm.get('confirmNewPassword')
            .hasError('mustMatch')) {
            <mat-error> Las contraseñas no coinciden.</mat-error>
            }
        </mat-form-field>
    </form>
</div>

<div mat-dialog-actions class="flex justify-end">
    @if (passwordChangeForm.disabled) {
    <button
        (click)="passwordChangeForm.enable()"
        [color]="'primary'"
        mat-flat-button
    >
        <mat-icon [svgIcon]="'heroicons_outline:pencil-square'"></mat-icon>
        <span class="ml-2 mr-1">Editar</span>
    </button>
    }@else{
    <button (click)="initialForm()" [color]="'warn'" mat-flat-button>
        <mat-icon [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
        <span class="ml-2 mr-1">Cancelar</span>
    </button>
    @if (passwordChangeForm.invalid) {
    <button disabled mat-flat-button>
        <mat-icon [svgIcon]="'heroicons_solid:plus'"></mat-icon>
        <span class="ml-2 mr-1">Actualizar</span>
    </button>
    }@else{
    <button (click)="changePassword()" [color]="'primary'" mat-flat-button>
        <mat-icon [svgIcon]="'heroicons_solid:plus'"></mat-icon>
        <span class="ml-2 mr-1">Actualizar</span>
    </button>
    }}
</div>
